import { useEffect } from 'react';
import { useAuthStore } from 'src/stores/useUserStore';

export function AuthStateProvider({ children }: React.PropsWithChildren) {
  const authStore = useAuthStore();

  useEffect(() => {
    return authStore.onMounted();
  }, [authStore]);

  return <>{children}</>;
}
